import { render } from "./SyncDialog.vue?vue&type=template&id=ceb39e9e&scoped=true"
import script from "./SyncDialog.vue?vue&type=script&lang=js"
export * from "./SyncDialog.vue?vue&type=script&lang=js"

import "./SyncDialog.vue?vue&type=style&index=0&id=ceb39e9e&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb39e9e"]])

export default __exports__